<script setup lang="ts">
import { HiddenField } from "@formwerk/core";

defineProps<{ resetKey: string; login: string }>();
const { result, onSubmit, isSubmitting } = useAuthResetPasswordForm();
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit">
    <HiddenField name="reset_key" :value="resetKey" />
    <HiddenField name="login" :value="login" />
    <FieldText name="password" type="password" label="Nouveau mot de passe" required />
    <UiSubmitButton :is-submitting="isSubmitting">
      Enregistrer
    </UiSubmitButton>
  </UiFormWrapper>
</template>
